
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { BotsCheck } from '@src/lib/commonLib/BotsCheck';
import { MARKETING_MATURE } from '@src/view/components/viewer/data';
import { SeoComponent } from '@src/view/common/seo';
import { TopcoPartner } from '@src/lib/partner';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { getViewerUrl } from '@src/lib/utils/routerUtils';
import { isRefererCheck } from '@src/lib/utils/utils';
import { matureComicPath } from '@src/constants/Episode';
import React from 'react';

const ViewerComponent = dynamic<any>(
  () => import('@src/view/components/viewer/ViewerComponent'),
  {
    ssr: false,
  },
);

const Index = (props: any) => {
  const {
    comic,
    episode,
    comicTitle,
    description,
    thumbnail,
    isBot,
    isReferer,
  } = props;

  return (
    <>
      <SeoComponent.Viewer
        title={!isBot ? comicTitle : ''}
        path={getViewerUrl(comic, episode)}
        description={!isBot ? description : ''}
        thumbnail={thumbnail}
      />
      <ViewerComponent
        marketingMature={MARKETING_MATURE.UNSET}
        comicId={comic}
        episodeId={episode}
        isReferer={isReferer}
      />
    </>
  );
};

 async function _getServerSideProps(context: any) {
  const { query } = context;
  const { comicId, episodeId } = query;
  const isReferer = isRefererCheck(context);
  const comic: number = Number(comicId);
  const episode: number = Number(episodeId);

  console.log('topcoLog viewer', query);

  if (_.isNaN(comic) || _.isNaN(episode)) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  const ret = await TopcoPartner.setterSSR(context);
  if (ret) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  try {
    const res = await fetch(matureComicPath);
    const comicSSR = await res.json();
    let title: string = '';
    let description: string = '';
    let thumbnail = {
      path: '',
      width: 0,
      height: 0,
    };
    // 봇인지 판단하는 value 아래에서 사용
    let isBot = false;

    if (comicSSR) {
      const search = _.filter(comicSSR, { comicId: comic });

      if (search.length > 0) {
        const current = search[0];

        title = current.title;

        /**
         * http://localhost:3000/content/Sir-Please-Be-Gentle/102013/125728
         * 구글 봇이 검색을 하지 못하게 하는 값 추출
         * isBlockBot == 0 검사안함 1 검사
         * 1차 봇 여부 확인 Googlebot, AdsBot
         * 2차 만화마다 봇 체크 상태값 확인
         */
        const isBlockBot = current.isBlockBot ?? 0;
        // TODO: 관리자에서 봇체크 설정을 모두 관리할수 없기 때문에 현재 성인이면 title, description 안보이게 설정하도록 함.
        isBot =
          isBlockBot == 1 &&
          BotsCheck.isGoogleBot(context.req.headers['user-agent']);
        // current.mature === 1;

        description = current.description ?? '';

        // thumbnail = current.titleVerticalThumbnail
        //   ? current.titleVerticalThumbnail['webp']
        //   : '';
      }
    }

    return {
      props: {
        isReferer,
        comic,
        episode,
        comicTitle: title,
        description,
        thumbnail,
        isBot,
      },
    };
  } catch (err: any) {
    console.error(err);
  }
}

export default Index;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/content/[comicId]/[episodeId]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  